<template>
   <!-- v-if="show" -->
  <div :class="bem()">

    <v-layout row wrap style="max-width:350px;">
      <v-flex xs4>
        <slot name="header"></slot>
      </v-flex>
      <v-flex xs8>
        <v-text-field placeholder="Search"
          class="searchInput"
          v-model="facetSearch"
          v-if="showSearchInput"
          width="50px" clearable
          @click:clear="clearFacetSearch" />
      </v-flex>
    </v-layout>
    <div v-bind="bind_facet_values">
      <div v-for="facet in facetValues" :key="facet.name" :class="facet.isRefined ? bem('item', 'active') : bem('item')">
        <!-- :label="`${facet.name.length > 28 ? facet.name.substring(0,28) + '...': facet.name} (${facet.count})`" -->
        <v-checkbox
          :label="`${facet.name} (${facet.count})`"
          :class="bem('checkbox') "
          @change="toggleRefinement(facet)"
          v-model="facet.isRefined"
          :active="facet.isRefined"></v-checkbox>
      </div>
    </div>
    <div v-if="facetValues.length == 0" class="v-label no-result">
      No result
    </div>
    <slot name="footer"></slot>
  </div>
</template>

<script>
import { RefinementList } from 'vue-instantsearch'
export default {
  name: 'ais-refinement-list',
  extends: RefinementList,
  data () {
    return {
      facetSearch: ''
    }
  },
  props: {
    showSearchInput: {
      type: Boolean,
      default: false
    },
    showScrollBar: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    bind_facet_values () {
      const binding = {}
      if (this.showScrollBar && this.facetValues.length > 7) binding.style = 'height: 197px; overflow: auto;'
      return binding
    },
    facetValues () {
      let patt = new RegExp('(' + this.facetSearch + ').*', 'gi')
      let offset = 9
      if (this.showScrollBar) {
        offset = 10000
      }
      return this.searchStore.getFacetValues(
        this.attributeName,
        this.sortBy,
        -1
      ).filter(x => this.facetSearch ? patt.exec(x.name) : x).slice(0, offset)
    }
  },
  mounted () {
    if (this.attributeName==="smartTags.n" && this.$route.params.smartTag) {
      this.searchStore.addFacet("smartTags.n", "and")
      this.searchStore.toggleFacetRefinement(
        this.attributeName,
        this.$route.params.smartTag
      )
        console.log(this.searchStore)
        console.log(this.searchStore)
    }
  },
  methods: {
    clearFacetSearch () {
      this.facetSearch = ''
      console.log(this.searchStore)
    }
  }
}
</script>
<style>

.ais-refinement-list .v-input--selection-controls {
  margin-top: 0px;
  padding-top: 0px;
}
.ais-refinement-list .v-input--selection-controls .v-input__slot {
  margin-bottom: 0px;
}
.ais-refinement-list .v-input__slot {
  margin-bottom: 0px;
}
.ais-refinement-list .v-messages{
  min-height: 0px!important;
}

.ais-refinement-list {
  margin-bottom: 10px;
}
.ais-refinement-list h3 {
  margin-top: 2px;
}
.searchInput {
  max-width: 300px;
  margin-top: 0px;
  padding-top: 0px;
  padding-bottom: 10px;
}
.no-result {
  color: rgba(0, 0, 0, 0.63);
  padding: 5px 0px 5px;
  margin-bottom: 3px;
  background-color: #fafafa;
  max-width: 98%;
}

.ais-refinement-list__item {
  background-color: #fafafa;
  max-width: 98%;
}

</style>
